import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-about-us-banner',
    standalone: true,
    imports: [CommonModule, TranslateModule],
    templateUrl: './about-us-banner.component.html',
})
export class AboutUsBannerComponent {}
